import React, { useState, useEffect, useRef } from "react";
import Carousel from "react-elastic-carousel";
import DeletePopup from "./Common/DeletePopup";
import { useDispatch, useSelector } from "react-redux";
import { removeFile } from "../Actions/uploadFileActions";

export default function ABCarouselScotland(props) {
  const dispatch = useDispatch();
  const { items, record } = props;
  const [deleteItem, setdeleteItem] = useState();

  const handleRemoveClick = (e, id) => {
    e.preventDefault();
    setdeleteItem(id);
    setShowDeleteModal(1);

  };

  const [showDeleteModal, setShowDeleteModal] = useState(0);

  const closeDeleteModal = () => {
    setShowDeleteModal(0);
  };

  const openDeleteModal = () => {
    setShowDeleteModal(1);
  };

  const deleteHandler = () => {
    setShowDeleteModal(1);
  };

  const proceedDelete = () => {
    const recordArray = {};
    recordArray.doc_chk = record.caseCheckId;
    recordArray.doc_ids = record.docId;
    recordArray.doc_ref = deleteItem;

    dispatch(removeFile("check_documents", recordArray));
    const newArr = removeObjectWithId(items, deleteItem);
    props.reRenderAgain();
    setShowDeleteModal(0);
  };

  function removeObjectWithId(arr, id) {
    const objWithIdIndex = arr.findIndex((obj) => obj.id === id);
    arr.splice(objWithIdIndex, 1);
    return arr;
  }

  return (
    <>
      {/* <button onClick={()=>closeModal(false)}>X</button> */}

      {items.length > 0 ? (
        <>
          <Carousel>
            {items.map((item, key) => (
              <div
                key={key}
                id={item.id}
                className="d-flex flex-column align-items-center"
              >
                <button class="btn btn-dark remove-btn"> <i class="fa-solid fa-download"></i>
                  <a href={item.image} download style={{color: 'white', textDecoration: 'none'}}> Download File</a>
                </button>
                <button
                  class="btn btn-outline-secondary mt-3 mr-2"
                  onClick={(e) => handleRemoveClick(e, item.id)}
                >
                  <i class="far fa-trash-alt mr-2"></i>
                  Remove
                </button>
              </div>
            ))}
          </Carousel>

          {showDeleteModal === 1 && (
            <DeletePopup
              showModalBox={showDeleteModal}
              closePopup={closeDeleteModal}
              title="Delete Image"
              description="Are you sure you want to delete this image? This action cannot be undone."
              proceedHandler={proceedDelete}
              // record={record}
            />
          )}
        </>
      ) : (
        <>{/* <center>No item found</center> */}</>
      )}
    </>
  );
}
